import {mergeLegacyEarthQuery} from './camera-state.js';
// Config runtime della v2: default vista, endpoint, deep-link.
// Gli endpoint sono gli STESSI della v1 (nessun backend nuovo): la v2 è un
// front-end diverso sopra le medesime API.

export const API_BASE = 'https://api.weathersicily.it';

export const DEFAULT_VIEW = {
    center: [14.15, 37.55], // [lng, lat] — MapLibre usa lng,lat
    zoom: 8,
    minZoom: 1,
    maxZoom: 18.5,
};

// Inquadratura "Sicilia intera": stretta sull'isola vera e propria (Egadi→Messina,
// Portopalo→costa nord) così resta grande e centrata, tagliando mare/Calabria in
// eccesso. [lng,lat] come vuole MapLibre fitBounds. Sorgente unica per deep-link
// (view=sicilia), rendering bot e reset "Tutte" nel filtro province.
export const SICILY_BOUNDS = [[12.38, 36.58], [15.62, 38.32]];

// Deep-link: parametri URL letti al boot (parità v1: lat/lon/zoom/station/…
// la lista completa arriva dalla checklist PARITY).
export function readUrlState() {
    const q = mergeLegacyEarthQuery(new URLSearchParams(window.location.search), window.location.hash);
    const num = (k) => { const v = parseFloat(q.get(k)); return Number.isFinite(v) ? v : null; };
    return {
        lat: num('lat'),
        lon: num('lon') ?? num('lng'),
        zoom: num('zoom') ?? num('z'),
        station: q.get('station') || q.get('stazione') || null,
        layers: (q.get('layers') || '').split(',').filter(Boolean),
        base: q.get('base') || null,
        lang: q.get('lang') || null,
        raw: q,
    };
}

export const STORAGE = {
    theme: 'ws-theme',            // condiviso con la v1: 'dark' | 'light'
    lang: 'ws-lang',              // condiviso con i18n v1
    layers: 'wsv2-layers',        // set layer attivi persistito
    base: 'wsv2-base',
    views: 'wsv2-saved-views',
};

export function isMobile() {
    return window.matchMedia('(max-width: 820px)').matches;
}
